export const AUTH_STORAGE_KEY = "sugar.auth.v1";

export type AuthUser = {
  id?: string | null;
  companyId?: string | null;
  email?: string | null;
  username?: string | null;
  companyName?: string | null;
};

export type AuthRecord = {
  ticket: string;
  expiresAt?: string | null;
  user?: AuthUser | null;
};

export type AuthCompanyOption = {
  companyId: string;
  name: string;
  slug?: string | null;
  available?: boolean;
};

export type PlannerAuthResponse = {
  status: string;
  ticket?: string | null;
  expiresAt?: string | null;
  user?: AuthUser | null;
  selectionToken?: string | null;
  companies?: AuthCompanyOption[];
  errorCode?: string | null;
};

export class AuthCancelledError extends Error {
  constructor() {
    super("Login cancelled");
    this.name = "AuthCancelledError";
  }
}

export function isAuthRecordExpired(record: AuthRecord | null): boolean {
  if (!record?.ticket) return true;
  if (!record.expiresAt) return false;
  const expires = Date.parse(record.expiresAt);
  if (Number.isNaN(expires)) return false;
  return expires <= Date.now() + 15_000;
}
